<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="fromAlarmType" ref="fromAlarmType">
                <td-permission :permissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.NAME')" prop="sName">
                            <td-input v-model="fromAlarmType.sName"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnQuery">{{ $t('common.QUERY') }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddType">{{ $t('common.ADD') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :dataSource="tableData"
                :columns="columns"
                :hasTreeTable="hasTreeTable"
                :hasIndex="hasIndex"
                :hasMutiSelect="hasMutiSelect"
                :hasPage="hasPage"
                childrenName="children"
                :hasLoading="hasLoading"
                :permissions="permissionsQuery"
                :rowKey="rowKey"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-typeInfo
                v-if="dialogTypeVisible"
                :isAddData="isAddData"
                :dialogTypeVisible="dialogTypeVisible"
                :editItem="editItem"
                :title="title"
                @typeDialogClose="typeDialogClose"
                @submit="submit"
            ></dialog-typeInfo>
        </el-main>
    </el-container>
</template>

<script>
import api from './assets/api.js';
import dialogTypeInfo from './components/dialogAlarmTypeInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-typeInfo': dialogTypeInfo
    },
    // 定义数据
    data() {
        return {
            fromAlarmType: { sName: '' },
            permissionsQuery: ['alarmType:view'],
            permissionsAdd: ['alarmType:add'],
            editItem: '',
            dialogTypeVisible: false,
            dialogClassifyVisible: false,
            tableData: [],
            hasTreeTable: true,
            hasIndex: false,
            hasMutiSelect: false,
            hasPage: false,
            isAddData: true, // 是否为添加数据
            loading: false, // 按钮是否为加载状态
            rowKey: 'id',
            columns: [
                {
                    prop: 'typeName',
                    label: this.$t('common.NAME')
                },
                {
                    prop: 'sDescribe',
                    label: this.$t('common.DESCRIPTION')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmType:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmType:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.id]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sName: this.fromAlarmType.sName,
                isPage: false
            };
            api.getAlarmType(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getAlarmType', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.loading = false;
            });
        },
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 添加
        btnAddType() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogTypeVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogTypeVisible = true;
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS_EX'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteAlarmType(JSON.stringify(sId), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/deleteAlarmType', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        typeDialogClose() {
            this.dialogTypeVisible = false;
        }
    }
};
</script>
